import Button from 'components/ReusableComponents/Button'
import { useState } from 'react'
import pmsApi from 'services/api/pms'

import styles from './GXPLogin.module.scss'
import { useGXPLogin } from './GXPLoginContext'

export default function UserWaitingApprovalStep() {
  const [loading, setLoading] = useState(false)
  const { setActiveStep, pushToData } = useGXPLogin()

  const handleClick = async () => {
    setLoading(true)
    const res = await pmsApi.updateMarriotGxpConfig({
      activeStep: 'UserGettingRegionalAccess'
    })
    pushToData(res)
    setActiveStep('UserGettingRegionalAccess')
    setLoading(false)
  }

  return (
    <div>
      <p className={styles.cardTitle}>Pending email confirmation from Marriott</p>

      <p className={styles.cardText}>
        Once you’ve received the email with user credentials, click on the button below.
      </p>

      <Button onClick={handleClick} disabled={loading}>
        I’ve received the credentials
      </Button>
    </div>
  )
}
